import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles, Button } from "@material-ui/core";
import PaperContainer from '../../Common/PaperContainer';
import SaveButton from '../../SettingsComponents/Shared/SaveButton';
import RentDefaultSettings from "./RentDefaultSettings";
import RentChecklist from "./RentChecklist";
import t from "../../../languages/pl";
import ActionCreator from './../../../store/actions/index';

const useStyles = theme => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    checksContainer: {
        marginTop: theme.spacing(2),
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        [theme.breakpoints.down("md")]: {
            flexDirection: "column"
        }
    },
    backToDefaultsBtn: {
        position: "absolute",
        top: 16,
        right: 16
    }
});

const RentSettings = props => {
    const { classes, data, resetRentSettingsToDefaults, saveActive } = props;
    const [state, setState] = useState(null);
    const { stan_rozpoczecia, stan_zakonczenia, domyslne_ustawienia } = data;

    const handleChange = (name, data) => {
        setState(prevState => ({
            ...prevState,
            [name]: data
        }));
    };

    const handleBackToDefaults = () => {
        resetRentSettingsToDefaults();
    };

    return (
        <PaperContainer>
            <div className={classes.container}>
                <RentDefaultSettings
                    data={domyslne_ustawienia}
                    onChange={(data) => handleChange("domyslne_ustawienia", data)}
                    onContentChanged={(value) => props.changeSaveRentSettings("domyslne_ustawienia", value)}
                />
            </div>
            <div className={classes.checksContainer}>
                <RentChecklist
                    title={t.conditionBeforeRent}
                    data={stan_rozpoczecia}
                    onChange={(data) => handleChange("stan_rozpoczecia", data)}
                    onContentChanged={(value) => props.changeSaveRentSettings("stan_rozpoczecia", value)}
                />
                <RentChecklist
                    title={t.conditionAfterRent}
                    data={stan_zakonczenia}
                    onChange={(data) => handleChange("stan_zakonczenia", data)}
                    onContentChanged={(value) => props.changeSaveRentSettings("stan_zakonczenia", value)}
                />
            </div>
            <Button
                variant="contained"
                color="secondary"
                className={classes.backToDefaultsBtn}
                onClick={handleBackToDefaults}
            >
                {t.backToDefaults}
            </Button>
            <SaveButton
                visible={Boolean(saveActive)}
                onClick={() => props.sendChangedSettings(state)}
            />
        </PaperContainer>
    );
};

const mapStateToProps = (state) => ({
    saveActive: Object.values(state.rentReducer.readyToSave).includes(true),
    data: state.rentReducer.settings,
    stan_rozpoczecia: state.rentReducer.settings.stan_rozpoczecia,
    stan_zakonczenia: state.rentReducer.settings.stan_zakonczenia,
    domyslne_ustawienia: state.rentReducer.settings.domyslne_ustawienia
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


RentSettings.propTypes = {
    classes: PropTypes.object,
    resetRentSettingsToDefaults: PropTypes.func,
    saveActive: PropTypes.bool,
    //redux
    data: PropTypes.object,
    stan_rozpoczecia: PropTypes.object,
    stan_zakonczenia: PropTypes.object,
    domyslne_ustawienia: PropTypes.object,
    changeSaveRentSettings: PropTypes.func,
    sendChangedSettings: PropTypes.func
};

export default compose(
    withStyles(useStyles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(RentSettings);
